export enum ImpactSettingType {
  area = "area",
  checkbox = "checkbox"
}

export enum SelectType {
  Single = "Single",
  Multiple = "Multiple"
}

export enum FillColor {
  select = "ff0000",
  unselect = "ffffff"
}
